var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('FromTo',{on:{"input":function($event){return _vm.registerAnalytic(_vm.name, 'aggregation_plot', 'from_to_change', _vm.fromToParameters)}},model:{value:(_vm.fromToParameters),callback:function ($$v) {_vm.fromToParameters=$$v},expression:"fromToParameters"}}),_c('Plotly',{attrs:{"layout":_vm.plotlyLayout,"data":_vm.plotlyData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }